export default "../css/d52a01d17b566af4e09658f7a0afd6f7.ttf";